import {
  globalAxios,
  backendVersion,
  managerInstance,
  merchantInstance,
} from "@/axios-path.js";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    userData: [],
    Commissionbyid: [],
    commissionlist: [],
    DistrcitCommissionByid: []
  },
  mutations: {
    resetState(state) {
      state.userData = [];
    },

    getDataCommission(state, data) {
      state.commissionlist = data;
    },
    deleteUser(state, item) {
      const index = state.userData.indexOf(item);
      state.userData.splice(index, 1);
    },

    addUser(state, user) {
      state.commissionlist.push(user);
    },
    editing(state, index) {
      state.indexEditLoading = index;
    },

    setCommissionById(state, data) {
      state.Commissionbyid = data;
    },
    setDistrcitCommissionById(state, data) {
      state.DistrcitCommissionByid = data;
    }
  },

  actions: {


    async fetchManagerCommission({ commit }, config) {
      let url = backendVersion.version + "/partner/get_commission_area";
      return managerInstance
        .get(url, { params: config })
        .then((res) => {
          if (res.msg == false) return false;
          commit("getDataCommission", res.data);
          return res.data;
        })
        .catch((err) => {
          return [];
        });
    },

    async fetchManagerCommissionByid({ commit }, { manager_id }) {
      let url = `${backendVersion.version
        }/partner/get_commission_area_by_id/${manager_id}`;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setCommissionById", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async fetchDistrcitCommissionByid({ commit }, { manager_id }) {
      let url = `${backendVersion.version
        }/partner/get_district_commission_area?province_id=${manager_id}`;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          console.log(res.data)
          commit("setDistrcitCommissionById", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },

    async addCommission({ commit, dispatch }, commissionlist) {
      let url = backendVersion.version + "/partner/create_commission_area";
      let res = await dispatch(
        "fetchGeneral/coreCommissionPostData",
        { url, form: commissionlist },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        commit("addUser", res);
        return true;
      }
    },
    async deleteCommission({ commit, dispatch }, item) {
      let url =
        backendVersion.version + "/partner/delete_commission_area/" + item;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteUser", item);
      }
    },
    async editCommission({ commit, dispatch }, payload) {
      let edit = {
        commission_area_id: payload.commission_area_id,
        commission_area_province_id: payload.commission_area_province.commission_area_province_id,
        commission_area_district_id: payload.commission_area_district.commission_area_district_id,
        commission_area_extra_transport_price: payload.commission_area_extra_transport_price,
        commission_area_gp: payload.commission_area_gp,
        commission_area_fee_delivery: payload.commission_area_fee_delivery,
        commission_area_promotion: payload.commission_area_promotion,
        commission_area_fee_delivery_differentail: payload.commission_area_fee_delivery_differentail,
        commission_area_guarantee_fee: payload.commission_area_guarantee_fee,
        commission_area_small_order_price: payload.commission_area_small_order_price,
      };
      let url = backendVersion.version + "/partner/update_commission_area";
      return managerInstance
        .put(url, edit)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
  },
  getters: {},
};
